import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'
import i18n from '@/i18n'

import dayjs from 'dayjs'
import _ from 'lodash'
// Layouts
// import layoutDefault from '@/layouts/layoutDefault.vue'

const Home = () => import('./views/Home.vue')
const Voucher = () => import('./views/Voucher.vue')
const Auth = () => import('./views/Auth.vue')
const layoutFrameless = () => import('@/layouts/layoutFrameless.vue')
const layoutForMap = () => import('@/layouts/layoutForMap.vue')

const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (to.meta.scroll && savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 300)
      })
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/vouchers',
      name: 'Voucher',
      component: Voucher
    },
    {
      path: '/vouchers/:voucherId?',
      name: 'VoucherDetail',
      component: () => import('./views/VoucherDetail.vue'),
      props: true
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth,
      meta: {
        layout: layoutFrameless,
        cookie: false
      }
    },
    {
      path: '/collects/:keyword?',
      name: 'Collects',
      component: () => import('./views/Collects/index.vue'),
      meta: {
        scroll: true,
        hasSearchBar: true
      }
    },
    {
      path: '/hotels',
      name: 'HotelsList',
      component: () => import('./views/HotelsList.vue'),
      meta: {
        scroll: true,
        hasSearchBar: true
      }
    },
    {
      path: '/hotels/:hotelId?',
      name: 'HotelDetail',
      component: () => import('./views/HotelDetail.vue'),
      props: true,
      meta: {
        hasHotelNavigator: true,
        hasSearchBar: true
      }
    },
    {
      path: '/order',
      name: 'Order',
      component: () => import(/* webpackChunkName: "order" */ './views/Order/Order.vue'),
      props: true,
      redirect: { name: 'OrderDetail' },
      children: [
        {
          path: 'detail',
          name: 'OrderDetail',
          component: () => import(/* webpackChunkName: "order" */ './views/Order/OrderDetail.vue'),
          meta: {
            // isLogin: true
          }
        },
        {
          path: 'bid',
          name: 'OrderBid',
          component: () => import(/* webpackChunkName: "order" */ './views/Order/OrderBid.vue'),
          // meta: {
          //   isLogin: true
          // }
        },
        {
          path: 'result',
          name: 'OrderResult',
          props: true,
          component: () => import(/* webpackChunkName: "order" */ './views/Order/OrderResult.vue'),
          meta: {
            // isLogin: true
          }
        }
      ]
    },
    {
      path: '/callback',
      name: 'Callback',
      component: () => import(/* webpackChunkName: "order" */ './views/Callback.vue')
    },
    {
      path: '/user/',
      name: 'User',
      component: () => import(/* webpackChunkName: "user" */ './views/User/User.vue'),
      props: true,
      redirect: { name: 'UserSaved' },
      meta: {
        isLogin: true
      },
      children: [
        {
          path: 'saved',
          name: 'UserSaved',
          component: () => import(/* webpackChunkName: "user" */ './views/User/UserSaved.vue')
        },
        {
          path: 'history',
          name: 'UserHistory',
          component: () => import(/* webpackChunkName: "user" */ './views/User/UserHistory.vue')
        },
        {
          path: 'order',
          name: 'UserOrderDetail',
          component: () => import(/* webpackChunkName: "user" */ './views/User/UserOrderDetail.vue')
        },
        {
          path: 'points/',
          name: 'UserPoints',
          component: () => import(/* webpackChunkName: "user" */ './views/User/UserPoints.vue'),
          redirect: { name: 'UserPointsDiscount' },
          children: [
            {
              path: 'discount',
              name: 'UserPointsDiscount',
              component: () => import(/* webpackChunkName: "user" */ './views/User/UserPoints/UserPointsDiscount.vue')
            },
            {
              path: 'history',
              name: 'UserPointsHistory',
              component: () => import(/* webpackChunkName: "user" */ './views/User/UserPoints/UserPointsHistory.vue')
            },
            {
              path: 'invitation',
              name: 'UserPointsInvitation',
              component: () => import(/* webpackChunkName: "user" */ './views/User/UserPoints/UserPointsInvitation.vue')
            },
            {
              path: 'records',
              name: 'UserPointsRecords',
              component: () => import('./views/User/UserPoints/UserPointsRecords.vue')
            }
          ]
        },
        {
          path: 'info',
          name: 'UserInfo',
          component: () => import(/* webpackChunkName: "user" */ './views/User/UserInfo.vue')
        },
        {
          path: 'premium',
          name: 'UserPremium',
          component: () => import(/* webpackChunkName: "user" */ './views/User/UserPremium.vue')
        }
      ]
    },
    // {
    //   path: '/events/:eventId?',
    //   name: 'Event',
    //   component: () => import(/* webpackChunkName: "others" */ './views/Events/Event.vue')
    // },
    {
      path: '/events/:eventId?',
      name: 'Event',
      component: () => import(/* webpackChunkName: "others" */ './views/NewEvent/NewEvent.vue'),
      meta: {
        // layout: layoutFrameless
      }
    },
    {
      path: '/map/:placeCity?',
      name: 'HotelsMap',
      component: () => import(/* webpackChunkName: "others" */ './views/HotelsMap'),
      meta: {
        layout: layoutForMap,
        hasSearchBar: true,
        hideNavBar: true
      }
    },
    {
      path: '/promotion',
      name: 'Promotion',
      component: () => import(/* webpackChunkName: "others" */ './views/Promotion.vue')
    },
    {
      path: '/invitation',
      name: 'Invitation',
      component: () => import(/* webpackChunkName: "others" */ './views/Invitation.vue')
    },
    {
      path: '/applepay',
      name: 'ApplePay',
      component: () => import(/* webpackChunkName: "others" */ './views/ApplePay.vue')
    },
    {
      path: '/user-term',
      name: 'UserTerm',
      component: () => import(/* webpackChunkName: "others" */ './views/Policy.vue')
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import(/* webpackChunkName: "others" */ './views/Policy.vue')
    },
    {
      path: '/bid/policy',
      name: 'BidPolicy',
      component: () => import(/* webpackChunkName: "others" */ './views/BidPolicy.vue')
    },
    {
      path: '/projects/',
      name: 'Projects',
      redirect: { name: 'Revitalize' },
      component: () => import(/* webpackChunkName: "projects" */ './projects/index.vue'),
      children: [
        {
          path: 'revitalize',
          name: 'Revitalize',
          meta: {
            layout: layoutFrameless
          },
          component: () => import(/* webpackChunkName: "projects" */ './projects/revitalize.vue')
        }
      ]
    },
    {
      path: '/fbq',
      name: 'Facebook Pixel Redirect Test',
      meta: {
        layout: layoutFrameless,
        cookie: false
      },
      component: () => import(/* webpackChunkName: "others" */ './redirect/fbq.vue')
    },
    {
      path: '/pdf-viewer/:data?',
      name: 'PdfViewer',
      props: true,
      meta: {
        // layout: layoutFrameless,
        cookie: false
      },
      component: () => import(/* webpackChunkName: "others" */ './components/PdfViewer.vue')
    },
    {
      name: '404',
      path: '/404',
      component: () => import(/* webpackChunkName: "others" */ './views/NotFound.vue'),
      meta: {
        hasSearchBar: true
      }
    },
    {
      name: 'Socket',
      path: '/chat-juju',
      component: () => import('./views/Socket.vue'),
      meta: {
      }
    },
    {
      name: 'OnlineTravel',
      path: '/2025OWJITF',
      meta: {
        layout: layoutFrameless,
        cookie: false
      },
      component: () => import('./views/OnlineTravel.vue')
    },
    {
      path: '*',
      name: 'NotFound',
      redirect: '/404'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.query) {
    console.debug('[router] beforeEach:to.query', to.query)
    if (to.query.vtm_stat_id) {
      // 記錄聯盟網 token
      Vue.ls.set('vtm_stat_id', to.query.vtm_stat_id, 60 * 60 * 1000)
      const newTo = _.assign(to)
      delete newTo.query.vtm_stat_id
      next({
        ...newTo
      })
    }
    // 切換語言
    if (to.query.lang) {
      const isLang = _.find(store.getters['user/langsList'], lang => {
        return lang.code === to.query.lang
      })
      if (isLang) {
        store.commit('user/SET_LANG_WITHOUT_RELOAD', to.query.lang)
        // next()
      } else {
        to.query.lang = store.getters['user/selectedLang']
        const toWithQuery = Object.assign({}, to, {
          query: to.query
        })
        next(toWithQuery)
      }
    }
    // 確認日期
    if (to.query.start && to.query.end) {
      const newTo = _.assign(to)
      const today = dayjs()
      const start = dayjs(to.query.start)
      const end = dayjs(to.query.end)
      // MEMO 開始 不是日期
      // MEMO 結束 不是日期
      // MEMO 開始 在 今日 之前
      // MEMO 結束 在 明日 之前
      // MEMO 開始 等於 結束
      if (!start.isValid() || !end.isValid() || start.isBefore(today, 'day') || !end.isAfter(today, 'day') || start.isSame(end)) {
        delete newTo.query.start
        delete newTo.query.end
        next({
          ...newTo
        })
      }
    }
  }
  if (!from.matched.some(m => m.meta.isLogin) && to.matched.some(m => m.meta.isLogin)) {
    store.dispatch('user/fetchProfile').then(res => {
      if (res && res.status !== 200) {
        // store.dispatch('user/goLogin')
        console.debug('[login failed; redirect to Home]', res)
        if (store.getters['user/prevStepIsLogout']) {
          store.commit('user/SET_PREV_STEP_IS_LOGOUT', false)
          next({
            name: 'Home'
          })
        } else {
          store.dispatch('user/goLogin', { url: to.fullPath })
        }
      } else {
        // 已登入
        next()
      }
    }).catch(() => {
      next({
        name: 'Home'
      })
    })
  } else {
    if (store.getters['user/prevStepIsLogout'] && to.name !== 'Auth') store.commit('user/SET_PREV_STEP_IS_LOGOUT', false)
  }

  const isPolicyChecked = store.state.order.form.isPolicyChecked
  if (isPolicyChecked) {
    store.commit('order/SET_POLICY_CHECKED', false)
  }
  if (to.query.i18n === 'debug') {
    i18n.locale = 'no-such-locale'
    i18n.fallbackLocale = 'no-such-locale'
  }
  next()
  // if (process.env.NODE_ENV === 'development') {
  //   next()
  // } else {
  //   const currentAllowPages = ['Auth', 'Promotion']
  //   if (store.getters['isSuper'] || currentAllowPages.some(path => to.name === path)) {
  //     next()
  //   } else {
  //     next({ name: 'Promotion' })
  //   }
  // }
})

router.afterEach((to, from) => {
  // 如果不是初次進入就不執行
  if (from.name) return false

  // // 初次進入: 執行擷取網址到 store
  // const people = store.getters['search/people']
  // const adult = _.toSafeInteger(to.query?.adult)
  // const child = _.toSafeInteger(to.query?.child)
  // const childAge = _.isArray(to.query.childAge) ? to.query.childAge : []
  // // 擷取網址的成人數量
  // if (adult !== people.adult) {
  //   store.commit('search/SET_ADULT_COUNT', adult > 1 ? adult : 1)
  // }
  // // 擷取網址的小孩數量
  // if (child !== people.child) {
  //   store.commit('search/SET_CHILD_COUNT', child)
  // }
  // // 比對小孩數量與年紀記錄
  // if (childAge !== people.childAge) {
  //   const childCount = _.toSafeInteger(to.query.child)
  //   const ageLength = childAge.length
  //   let newAges = []
  //   if (childCount < ageLength) {
  //     newAges = _.take(childAge, childCount)
  //   }
  //   if (childCount === ageLength) {
  //     newAges = childAge
  //   }
  //   if (childCount > ageLength) {
  //     newAges = _.complete(childAge, '12', childCount)
  //   }
  //   for (const index in newAges) {
  //     newAges[index] = _.toSafeInteger(newAges[index])
  //   }
  //   store.commit('search/REPLACE_CHILD_AGES', newAges)
  // }
})

export default router
